import React, { useRef, useState, useCallback } from "react";
import Webcam from "react-webcam";
import axios from "axios";

const LiveCamera = () => {
  const webcamRef = useRef(null);
  const [facingMode, setFacingMode] = useState("user");
  const [showCamera, setShowCamera] = useState(false);
  const [image, setImage] = useState(null);
  const [uploading, setUploading] = useState(false);

  const videoConstraints = {
    facingMode: facingMode,
  };

  const switchCamera = () => {
    setFacingMode((prev) => (prev === "user" ? "environment" : "user"));
  };

  const toggleCamera = () => {
    setShowCamera((prev) => !prev);
    setImage(null);
  };

  const capture = useCallback(() => {
    const screenshot = webcamRef.current.getScreenshot();
    if (screenshot) {
      setImage(screenshot);
      setShowCamera(false);
      uploadImage(screenshot); // send image after capture
    }
  }, [webcamRef]);

  const uploadImage = async (base64Data) => {
    const blob = await fetch(base64Data).then(res => res.blob());
    const formData = new FormData();
    formData.append("image", blob, "captured.jpg");

    try {
      setUploading(true);
      const response = await axios.post("http://your-server.com/upload.php", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Upload Success:", response.data);
      alert("Image uploaded successfully!");
    } catch (err) {
      console.error("Upload Error:", err);
      alert("Image upload failed.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      {!image && (
        <button onClick={toggleCamera}>
          {showCamera ? "Close Camera" : "Open Camera"}
        </button>
      )}

      {showCamera && (
        <div style={{ marginTop: 10 }}>
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={videoConstraints}
            style={{ width: "100%", maxWidth: "400px" }}
          />
          <br />
          <button onClick={switchCamera}>
            Switch to {facingMode === "user" ? "Back" : "Front"} Camera
          </button>
          <button onClick={capture} style={{ marginLeft: 10 }}>
            Capture Image
          </button>
        </div>
      )}

      {image && (
        <div style={{ marginTop: 20 }}>
          <h4>Captured Image:</h4>
          <img
            src={image}
            alt="Captured"
            style={{ width: "100%", maxWidth: "400px" }}
          />
          <br />
          <button onClick={() => setImage(null)}>Retake</button>
        </div>
      )}

      {uploading && <p>Uploading...</p>}
    </div>
  );
};

export default LiveCamera;
